import types from './types'
import calc from './calculation-distance'

const Point = types.Point

function getLocation(info) {
  if (info.mappedPosition) {
    return [info.mappedPosition.latitude, info.mappedPosition.longitude]
  } else {
    return [info.latitude, info.longitude]
  }
}

function calculateInsertPointIndex(waypoints, insertPoint) {
  const reRoutePoints = waypoints
  let allPointsDistace = 0 // 路径上所有 waypoint 的总直线距离
  const twoWaypointsDistanceList = [] // 两个相邻的 waypoint 直线距离
  let insertCoordinates = new Point(...getLocation(insertPoint))
  const insertPointDistanceList = [] // 插入点与每个点的直线距离
  reRoutePoints.forEach((point, index) => {
    const coordinates = new Point(...getLocation(point))
    //Calculate distance between waypoints and insert point
    insertPointDistanceList.push(calc(coordinates.lat, coordinates.lng, insertCoordinates.lat, insertCoordinates.lng))
    if (index + 1 < reRoutePoints.length) {
      const afterOnePoint = reRoutePoints[index + 1]
      const afterOneCoordinates = new Point(...getLocation(afterOnePoint))
      const twoWaypointDistance = calc(coordinates.lat, coordinates.lng, afterOneCoordinates.lat, afterOneCoordinates.lng)
      twoWaypointsDistanceList.push(twoWaypointDistance)
      allPointsDistace += twoWaypointDistance
    } else {
      twoWaypointsDistanceList.push(0)
    }
  })
  const twePointDistanceList = []
  insertPointDistanceList.forEach((fl, index) => {
    if (index + 1 < insertPointDistanceList.length) {
      twePointDistanceList.push(fl + insertPointDistanceList[index + 1])
    } else {
      twePointDistanceList.push(fl)
    }
  })
  const allPointsAfterInsertDistanceList = []
  twoWaypointsDistanceList.forEach((twoWaypointDistance, index) => {
    allPointsAfterInsertDistanceList.push(allPointsDistace - twoWaypointDistance + twePointDistanceList[index])
  })
  const arrivedSize = 0
  const insertPointIndex = allPointsAfterInsertDistanceList.indexOf(Math.min(...allPointsAfterInsertDistanceList)) + 1
  return insertPointIndex + arrivedSize
}

export default calculateInsertPointIndex
